module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/445.b52595c2.png";